// extracted by mini-css-extract-plugin
module.exports = {"modal":"ReviewsSort_modal__g1yG2","modal-heading":"ReviewsSort_modal-heading__hN_EC"};